import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import CurrencyCode from 'types/CurrencyCode';
import PlanCode from 'types/PlanCode';
import Plan from 'types/Plan';
import * as formStyles from 'components/forms/styles/styles.module.scss';
import PlanTypeCardCollection from 'components/forms/pro/PlanTypeCardCollection';
import Coupon from 'types/Coupon';
import * as baseStyles from '../../../styles/baseStyles.module.scss';
import * as styles from './GiftPlan.module.scss';

type Props = {
  activePlanType?: PlanCode;
  buttonText: string;
  currencyCode: CurrencyCode;
  handleClick?(...args: unknown[]): unknown;
  handleSubmit?(...args: unknown[]): unknown;
  headerText: ReactNode;
  isCouponApplied?: boolean;
  planTypes: Plan[];
  verifiedCoupon?: Coupon;
};

function GiftPlan({
  buttonText,
  headerText,
  planTypes,
  handleClick,
  activePlanType,
  currencyCode,
  verifiedCoupon,
  isCouponApplied,
  handleSubmit
}: Props) {
  return (
    <div className={styles.planTypeContainer}>
      <div className={(baseStyles.container, formStyles.container)}>
        {planTypes.length > 1 && <div className={styles.pickYourPlan}>{headerText}</div>}
        <div className={baseStyles.section}>
          <div className={(baseStyles.row, formStyles.group)}>
            <div className={baseStyles.row}>
              <PlanTypeCardCollection
                activePlanType={activePlanType}
                currencyCode={currencyCode}
                handler={handleClick}
                isCouponApplied={isCouponApplied}
                planTypes={planTypes}
                verifiedCoupon={verifiedCoupon}
              />
            </div>
          </div>
          <div className={baseStyles.row} data-testid="Get Started">
            <Button text={buttonText} onClick={handleSubmit} testId={buttonText} variant="primary" />
          </div>
        </div>
        <div className={styles.cancel}>
          <FormattedMessage defaultMessage="Cancel within 30 days and receive a full-refund." />
        </div>
      </div>
    </div>
  );
}

export default GiftPlan;
